import { useEffect, useState } from 'react'
import { Button } from '../../atoms'
import { buttonsContainer, container, submitButton } from './index.css'

export const ModalConfirmation = (props: {
  text: string
  mainButtonText?: string
  secondaryButtonText?: string
  timeoutSeconds?: number
  onClose: (result: 'main' | 'secondary') => void
}) => {
  const [remainingTime, setRemainingTime] = useState(props.timeoutSeconds)

  useEffect(() => {
    setRemainingTime(props.timeoutSeconds)
  }, [props.timeoutSeconds])

  useEffect(() => {
    if (remainingTime === undefined || remainingTime <= 0) return

    const interval = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev !== undefined) {
          if (prev <= 1) {
            clearInterval(interval)
            props.onClose('secondary')
            return 0
          }
          return prev - 1
        }
        return prev
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [remainingTime])

  const secondaryLabel = props.secondaryButtonText || 'Cancel'
  const secondaryText =
    remainingTime !== undefined && remainingTime > 0
      ? `${secondaryLabel} (${remainingTime})`
      : secondaryLabel

  return (
    <div className={container}>
      <span>{props.text}</span>
      <div className={buttonsContainer}>
        <Button
          onClick={() => props.onClose('secondary')}
          variant='bordered'
          analytic={{
            name: 'cancel',
            params: {
              modal: 'confirmation',
            },
          }}
          className={submitButton}
        >
          {secondaryText}
        </Button>
        <Button
          onClick={() => props.onClose('main')}
          variant='primary'
          analytic={{
            name: 'confirm',
            params: {
              modal: 'confirmation',
            },
          }}
          className={submitButton}
        >
          {props.mainButtonText || 'Confirm'}
        </Button>
      </div>
    </div>
  )
}
